(function(){
  'use strict';

  angular
    .module('app')
    .component('disqus', disqusComponent());

  function disqusComponent() {
    return {
      template: '<div id="disqus_thread"></div>',
      bindings: {},
      controller: DisqusController,
      controllerAs: '$ctrl',
      transclude: false
    }
  }

  function DisqusController(disqusConfig) {
    let vm = this;
    vm.$onInit = () => {
      if(disqusConfig){
        invoke();
      } else {
        console.error('You need define disqusConfig constant');
      }
    }

    function invoke(){
      var d = document, s = d.createElement('script');
      s.src = `//${disqusConfig}.disqus.com/embed.js`;
      s.setAttribute('data-timestamp', +new Date());
      (d.head || d.body).appendChild(s);
    }
  }

})();
